import { gql } from '@apollo/client';

export default gql`
  mutation respondToSuggestion(
    $_id: String
    $status: String
    $response: String
  ) {
    respondToSuggestion(
      _id: $_id
      status: $status
      response: $response
    ) {
      ok
      error
      data
    }
  }
`;
